// components/GoogleTagManager.js
'use client';

import { GoogleTagManager } from '@next/third-parties/google';

export default function GoogleTagManagerClient() {
  return <GoogleTagManager gtmId={process.env.GTM_TAG || ''} />;
}
